module.exports = {
  title: '安卓下载链接',
  route: {
    path: '/app-manage',
    children: {
      path: 'app-manage-android-load',
    },
  },
};
